import { isObjectLike } from './is-object-like.js';
import { isPlainObject } from './is-plain-object.js';
import { type } from './type.js';

/**
 * @description
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @example
 * ``` ts
 * isError(new Error());
 * // => true
 * isError(Error);
 * // => false
 * ```
 *
 * @param value The value to check.
 * @returns Returns `true` if `value` is an error object, else `false`.
 *
 * @docsCategory preference/lang
 * @codeFilter is-error
 */
export const isError = (value): value is Error => {
  if (!isObjectLike(value)) {
    return false;
  }
  return (
    type(value) === 'error' ||
    type(value) === 'domError' ||
    (typeof value.message == 'string' &&
      typeof value.name == 'string' &&
      !isPlainObject(value))
  );
};
